
import msDataProvider from "../../services/msDataProvider";
import {addAction} from "@/services/firebase/writeData";
import uiService from "@/services/uiService";
import ratingService from "@/services/ratingService";
import Feedback from "@/views/main/partials/options/Feedback.vue";
import Update from "@/views/main/partials/options/Update.vue";
import Devices from "@/views/main/partials/options/Devices.vue";
import Language from "@/views/main/partials/options/Language.vue";
import ContactAndSupport from "@/views/main/partials/options/ContactAndSupport.vue";

export default {
  components: {Language, Devices, Update, Feedback, ContactAndSupport},
  data() {
    return {
      selectedOptionItem: null,
      errorFeedback: "",
      feedbackSuccessfully: false,
      feedback: {
        content: "",
        attached_files: {},
      },
      updateStatus: {},
      binding: {},
      enrollmentCredentials: null,
      countIssue: 0,
      currentServerName: "",
      isShowDeviceTab: true
    };
  },
  async created() {
    this.checkDeviceOption();
    await msDataProvider.bindDataMany(
        [
          "authenAuthenInfo",
          "updateAvailableVersionsInfo",
          "updateApplied",
          "setting",
          "deviceIssues",
          "deviceDynamicInfo"
        ],
        this.binding,
        this,
        (key, data) => {
          if (key === "deviceIssues" && data.data) {
            this.countIssue = data.data.length;
          }
        },
        this
    );
    sessionStorage.removeItem("biometricData")
    this.currentServerName = await msDataProvider.executeCommand(
        "backendServerNameGetCurrentValue"
    );
    this.enrollmentCredentials = await msDataProvider.executeCommand(
        "enrollmentGetCredentials"
    );
    // init rating
    const authData = await msDataProvider.getData("authenAuthenInfo");
    if (authData.user_info?.user_id) {
      this.updateStatus = await msDataProvider.executeCommand("updateGetStatus");
      ratingService.initRatings(this.updateStatus.version, authData.user_info?.user_id);
    }
  },
  methods: {
    async goToFeedback() {
      this.selectedOptionItem = "feedback";
      await addAction('click_to_feedback')
    },
    async goToHelpCenter() {
      this.selectedOptionItem = "contact_and_support";
      await addAction('click_to_help_center')
    },
    async exit() {
      if (
          await uiService.executeCommand(
              "confirmShow",
              {
                message: this.$t("LAYOUT.DO_YOU_REALLY_WANT_TO_EXIT_THIS_APP"),
                title: this.$t("LAYOUT.CONFIRM_EXIT"),
                cancel: this.$t("LAYOUT.CANCEL"),
                ok: this.$t("LAYOUT.EXIT"),
              },
              true
          )
      ) {
        await uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand("appExit", {});
            this.$router.push("/prepare").catch((e) => e);
          },
          self: this,
        });
      }
      await addAction('click_to_exit_app')
    },
    async logout() {
      if (
          await uiService.executeCommand(
              "confirmShow",
              {
                message: this.$t("LAYOUT.DO_YOU_WANT_TO_LOGOUT_THIS_DEVICE"),
                title: this.$t("LAYOUT.LOGOUT"),
                cancel: this.$t("LAYOUT.CANCEL"),
                ok: this.$t("LAYOUT.LOGOUT"),
              },
              true
          )
      ) {
        await uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand("authenLogout", {});
            this.$router.push("/prepare").catch((e) => e);
          },
          self: this,
        });
        await addAction('click_to_logout')
        sessionStorage.removeItem('userId')
      }
    },

    goToUpdate() {
      this.selectedOptionItem = "update";
      addAction('click_to_check_update')
    },

    goToDeviceInfo() {
      this.selectedOptionItem = "devices";
      addAction('click_to_device_info')
    },

    goToSetLanguage() {
      this.selectedOptionItem = "set_lang";
    },
    checkDeviceOption() {
      this.isShowDeviceTab = !(this.$route.query && this.$route.query.hideDeviceOpt);
    },
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
};
